import React, { useState } from "react";
import { Avatar, Popover } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faSignOut } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import ChangePasswordPopup from "../../pages/Login/changePasswordPopup";
import { destore } from "../../store/features/orders/createSlice";
import { orderFilterDestore } from "../../store/features/Filters/orderSlice";
import { transationFilterDestore } from "../../store/features/Filters/transactionSlice";

const LoginHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  const logout = () => {
    Cookies.set("auth-token", "");
    localStorage.clear();
    dispatch(destore());
    dispatch(orderFilterDestore());
    dispatch(transationFilterDestore());
    navigate("/");
  };

  const closeModelPopup = () => {
    setShow(false);
  };

  const content = (
    <>
      <p
        onClick={(e) => {
          setShow(true);
        }}
      >
        <FontAwesomeIcon icon={faLock} className="me-2" />
        Change Password
      </p>
      <p
        onClick={(e) => {
          logout();
        }}
      >
        <FontAwesomeIcon icon={faSignOut} className="me-2" />
        Logout
      </p>
    </>
  );

  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      <div className="container-fluid">
        <a
          className="navbar-brand"
          onClick={() => {
            navigate("/");
          }}
        >
          <img src="/logo.png" alt="" className="log" />
        </a>
        <div>
          <Popover placement="bottom" content={content}>
            <Avatar icon={<UserOutlined />} />
          </Popover>
        </div>
      </div>
      <ChangePasswordPopup show={show} close={closeModelPopup} />
    </nav>
  );
};

export default LoginHeader;
